(function($) {
    $('[data-slide-toggle]').each(function() {
        $(this).css('display', 'none').removeClass('hide');
    });


    $('[data-slide-toggle-trigger]').click(function() {
        var name = $(this).data('slide-toggle-trigger');
        $('[data-slide-toggle="' + name + '"]').slideToggle();
    });

})(jQuery);
